import api from '@/api';
import { queryOptions } from '@tanstack/vue-query';
import { computed, type Ref } from 'vue';

export async function fetchInvitationUrl() {
  const response = await api<{ url: string }>({
    method: 'get',
    url: '/me/invitation/candidate',
  });

  return response;
}

export function setInvitationURLQuery(enabled: Ref<boolean>) {
  return queryOptions({
    queryKey: ['invitation-url'],
    queryFn: fetchInvitationUrl,
    enabled: computed(() => enabled.value),
  });
}
